import { RouteComponentProps } from 'react-router-dom'

const LogOut = (history: RouteComponentProps['history']) => {
  localStorage.removeItem('backoffice_user_access')
  localStorage.removeItem('backoffice_user_refresh')
  history.push('/login')
}

export { LogOut }
